import { axiosInstance } from "./axiosInstance";

// 파트너 목록 조회
export const getAdminPartners = async (page: number = 1, size: number = 10) => {
    const response = await axiosInstance.get(`/api/admin/partners?page=${page}&size=${size}`);
    return response.data;
};

// 파트너 상세 조회
export const getAdminPartnerDetail = async (partnerId: number) => {
    const response = await axiosInstance.get(`/api/admin/partners/${partnerId}`);
    return response.data;
};

// 신규 파트너 등록
export const createAdminPartner = async (data: any) => {
    const response = await axiosInstance.post("/api/admin/partners", data);
    return response.data;
};

// 파트너 수정
export const updateAdminPartner = async (partnerId: number, data: any) => {
    const response = await axiosInstance.put(`/api/admin/partners/${partnerId}`, data);
    return response.data;
};